<template>
	<div id="parent">
		<div class="header">
			
			<div class="left">
				<RadioGroup v-model="week_month" @on-change="periodClick">
				        <Radio label="日报"></Radio>
				        <Radio label="月报"></Radio>
				</RadioGroup>
				<div style="display: flex; align-items: center; margin-left: 20px; width: 150px; justify-content: space-between;">
					<!-- <Button type="primary" @click="prev">&lt;</Button> -->
					<div class="prev-css icon iconfont icon-zuojiantou" @click="prev"></div>
					<div>{{headerContent}}</div>
					<div class="prev-css icon iconfont icon-youjiantou" @click="next"></div>
					<!-- <Button type="primary" @click="next">&gt;</Button> -->
				</div>
			</div>
			<div><Button type="primary" @click='newAddClick'>新增</Button></div>
		</div>
		<div class="body">
			<table class="month-table" cellspacing="0" cellpadding="0" v-show="showMonth && week_month == '月报'">
				<tbody>
					<tr style="text-align: center; height: 60px;">
						<td>周一</td>
						<td>周二</td>
						<td>周三</td>
						<td>周四</td>
						<td>周五</td>
						<td>周六</td>
						<td>周日</td>
					</tr>
					<!-- 双重for循环生成 6 * 7 = 42 个日期格子 -->
					<tr v-for="(week, weekIndex) in dates" v-bind:key="weekIndex" style="height: 160px;">
						<td class="hand-css" v-for="(date, dateIndex) in dates[weekIndex]" v-bind:key="dateIndex" @mouseenter="dateMouseEnter(weekIndex, dateIndex)"
						 @mouseleave="dateMouseLeave(weekIndex, dateIndex)">
							<div class="date" :class="[date.class, date.isAlive]" @click="addTaskClick">
								<span>{{date.day}}</span>
								<div style=" display: flex; align-items: center; font-size: 10px; " v-for="(item,journeyIndex) in journey" :key="journeyIndex"
								 v-if="item.data == date.value">
									<div v-show='item.state == true' class="fill-month icon iconfont icon-yixuan" @click.stop="checkOut(item.id)"></div>
									<div v-show='item.state == false' class="fill-month icon iconfont icon-weixuanzhong" @click.stop="checkOut(item.id)"></div>
									<div class="yuanlan"></div>
									<div :class="{checkcss:item.state == false,journeytext:item.state == true}" @click.stop='taskDetailsClick(item.id)'>{{item.text}}</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<!-- 生成一个周 时间列表 -->
			<table class="week-table" cellspacing="0" cellpadding="0" v-show="!showMonth && week_month == '日报'">
				<!-- <thead>
					<th style="height: 60px; border: 1px solid #EBEEF5; position: relative;">
						<span style="position: absolute; top:10px; left: 140px;">日期</span>
						<div style="width: 200px; border-bottom: 1px solid #EBEEF5; transform: rotate(16.5deg);"></div>
						<span style="position: absolute; top:30px; left: 20px;">姓名</span>
					</th>
					<th style="height: 60px;border: 1px solid #EBEEF5;" v-for="(header, index) in weekTableHeader" :key="index" :class="header.class">{{header.date}}</th>
				</thead> -->
				<tbody>
					<tr>
						<td style="height: 60px; border: 1px solid #EBEEF5; position: relative;">
							<span style="position: absolute; top:10px; left: 140px;">日期</span>
							<div style="width: 200px; border-bottom: 1px solid #EBEEF5; transform: rotate(16.5deg);"></div>
							<span style="position: absolute; top:30px; left: 20px;">姓名</span>
						</td>
						<td style="height: 60px;border: 1px solid #EBEEF5; text-align: center;" v-for="(header, index) in weekTableHeader" :key="index" :class="header.class">
						<div style="height: 30px; line-height: 30px; border-bottom: 1px solid #EBEEF5;">{{header.date}}</div>
						<div style="height: 30px; line-height: 30px;">{{header.value}}</div>
						</td>
					</tr>
					<tr v-for="(hourMinute, index) in weekList" :key="index" style="height: 70px;">
						<td>
							<div class="hours">
								<span>{{hourMinute.name}}</span>
								<span style="color: #BABAB9;">{{hourMinute.title}}</span>
							</div>
						</td>
						<td v-for="(header, index) in weekTableHeader" :key="index" class="hand-css">
							<div @click="addTaskClick" class="scrollbar-css" style="height: 70px; overflow: auto;">
								<div style=" display: flex; align-items: center; font-size: 10px;" v-for="(item,journeyIndex) in journey" :key="journeyIndex"
								 v-if="hourMinute == item.interval && item.data == header.value">
									<div v-show='item.state == true' class="fill icon iconfont icon-yixuan" @click.stop="checkOut(item.id)"></div>
									<div v-show='item.state == false' class="fill icon iconfont icon-weixuanzhong" @click.stop="checkOut(item.id)"></div>
									<div class="yuanlan"></div>
									<div :class="{checkcss:item.state == false,journeytext:item.state == true}" @click.stop='taskDetailsClick(item.id)'>{{item.text}}</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		
			
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		components: {
		},
		data() {
			return {
				week_month:'日报',
				checkShow: false, //时间勾选样式
				today: moment().format('YYYY-MM-DD'),
				currentYearMonth: moment().format('YYYY-MM'),
				weekTableHeader: [],
				dates: [],
				showMonth: false,
				weekList: [{name:'王清',title:'北京品伦'}],
				//初始化页面显示的东西
				headerContent: moment().format('YYYY-MM'),
				currentWeekday: '',
				journey: [{
						data: '2020-10-19',
						interval: '9:00-10:00',
						text: '约见林其他合同0873825872普通',
						id: '1',
						state: false
					},
					{
						data: '2020-10-22',
						interval: '10:00-11:00',
						text: '约见老八其他合同0873825872普通',
						id: '2',
						state: true
					},
					{
						data: '2020-10-23',
						interval: '11:00-12:00',
						text: '约见老九其他合同0873825872普通',
						id: '3',
						state: true
					},
					{
						data: '2020-10-24',
						interval: '15:00-16:00',
						text: '约见三十其他合同0873825872普通',
						id: '4',
						state: false
					},
					{
						data: '2020-10-24',
						interval: '15:00-16:00',
						text: '约见三十其他合同0873825872普通',
						id: '4',
						state: false
					},
					{
						data: '2020-10-24',
						interval: '15:00-16:00',
						text: '约见三十其他合同0873825872普通',
						id: '4',
						state: true
					},
					{
						data: '2020-10-24',
						interval: '15:00-16:00',
						text: '约见三十其他合同0873825872普通',
						id: '4',
						state: true
					},
					{
						data: '2020-10-25',
						interval: '13:00-14:00',
						text: '约见老五其他合同0873825872普通',
						id: '5',
						state: false
					}
				],
			}
		},
		methods: {
			// 新增按钮
			newAddClick() {
				this.$emit('newAddClick')
			},
			//周期单选框选择触发
			periodClick(e) {
				if(e=='日报') {
					this.switchMonth()
				}else{
					this.switchWeek()
				}
			},
			// 新建任务
			addTaskClick() {
				this.modal4 = true
			},
			
			
			//事件中的文字点击触发
			taskDetailsClick(id) {
				this.modal2 = true
			},
			//事件前面的勾选框
			checkOut(id) {
			},
			// 点击上个月 通过改变currentYearMonth来获取上个月的 YYYY-MM 格式
			prev() {
				if (this.showMonth) {
					this.currentYearMonth = moment(this.currentYearMonth).subtract(1, 'months').format('YYYY-MM')
					this.headerContent = this.currentYearMonth
					this.createCalendar()
				} else {
					this.currentWeekday = moment(this.currentWeekday).subtract(7, 'days')
					this.weekHeaderContent()
					this.createWeekList()
				}
			},
			next() {
				if (this.showMonth) {
					this.currentYearMonth = moment(this.currentYearMonth).add(1, 'months').format('YYYY-MM')
					this.headerContent = this.currentYearMonth
					this.createCalendar()
				} else {
					this.currentWeekday = moment(this.currentWeekday).add(7, 'days')
					this.weekHeaderContent()
					this.createWeekList()
				}
			},
			switchWeek() {
				this.showMonth = true
				this.headerContent = this.currentYearMonth
			},
			switchMonth() {
				this.showMonth = false
				this.weekHeaderContent()
			},
			dateMouseEnter(weekIndex, dateIndex) {
				this.dates[weekIndex][dateIndex].isAlive = 'date-alive'
			},
			dateMouseLeave(weekIndex, dateIndex) {
				this.dates[weekIndex][dateIndex].isAlive = ''
			},
			createCalendar() {
				this.dates = []
				// 获取当月的一号是星期几 以便来生成上月的日期 填补够42个格子
				const monthFirstDay = moment(this.currentYearMonth + '-01', 'YYYY-MM-DD')
				// 获得一号与第一个格子内应该有的天数距离 这里需要注意的是 weekday 是从周日 为 0 开始的
				let firstDayWeekday = moment(monthFirstDay).weekday()
				if (firstDayWeekday === 0) {
					firstDayWeekday = 7
				}
				let daysDistance = 1 - firstDayWeekday
				for (let weeks = 0; weeks < 5; weeks++) {
					this.dates.push([])
					for (let weekday = 0; weekday < 7; weekday++) {
						// 该对象有两个属性 一个是class属性 还有一个就是日期
						let date = {}
						date.day = moment(monthFirstDay).add(daysDistance, 'days')
						date.value = date.day.format('YYYY-MM-DD')
						date.isAlive = ''
						const dayMonth = moment(date.day).month()
						// 是这个月的日期
						if (dayMonth === moment(monthFirstDay).month()) {
							date.class = 'current-month '
							// 日期是今天的高亮
							if (moment(date.day).isSame(this.today, 'days')) {
								date.class += 'today '
							}
						} else {
							date.class = 'not-current-month '
						}
						date.day = moment(date.day).format('DD')
						this.dates[weeks].push(date)
						daysDistance++
					}
				}
			},
			createWeekList() {
				this.weekTableHeader = ['周一 ', '周二 ', '周三 ', '周四 ', '周五 ', '周六 ', '周日 ']
				for (let index = 0; index < 7; index++) {
					let item = {}
					item.date = moment(this.currentWeekday).add(index, 'days')
					if (item.date.isSame(this.today, 'days')) {
						item.class = 'today'
					}
					item.value = item.date.format('MM-DD');
					// item.date = this.weekTableHeader[index] + item.date.format('MM/DD')
					item.date = this.weekTableHeader[index]
					
					this.weekTableHeader[index] = item
				}
			},
			weekHeaderContent() {
				this.headerContent = moment(this.currentWeekday).format('YYYY-MM')
				//moment(this.currentWeekday).format('MM/DD') + '~' + moment(this.currentWeekday).add(6, 'days').format('MM/DD')
			}
		},
		created() {
			// v-show是在创建后 保留dom 只是做切换的 不会v-if那样 销毁dom 所以只需要创建一次
			this.createCalendar()
			let weekday = moment().weekday() === 0 ? 7 : moment().weekday()
			let daysDistance = 1 - weekday
			this.currentWeekday = moment().add(daysDistance, 'days')
			this.createWeekList()
		}
	}
</script>

<style lang="less" scoped>
	.prev-css{
		color: #277dd3;
		font-size: 30px;
		cursor:pointer;
	}
	.left{
		width: 100%;
		display: flex;
		align-items: center;
	}
	.hand-css {
		cursor: pointer;
	}

	.journeytext {
		color: #999999;
		text-decoration: line-through
	}

	.checkcss {
		color: #FF0000;
		text-decoration: none
	}

	.yuanlan {
		height: 7px;
		width: 7px;
		background-color: #277dd3;
		border-radius: 50%;
		margin: 0 1px;
	}

	.scrollbar-css::-webkit-scrollbar {
		width: 5px;
		height: 4px;
		background-color: #f5f5f5;
	}

	.scrollbar-css::-webkit-scrollbar-thumb {
		border-radius: 3px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
		background: #cae1f5;
	}

	.scrollbar-css::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
		background: #fff;
	}

	.fill {
		font-size: 15px;
		margin-left: 5px;
		color: #277dd3;
	}
	.fill-month {
		font-size: 15px;
		color: #277dd3;
	}

	#parent {
		margin: 0 auto;
	}

	.header {
		display: flex;
		justify-content: space-between;
		padding: 12px 20px;
		font-size: 18px;
	}

	.body {
		padding: 12px 20px 35px;
	}

	table {
		table-layout: fixed;
		width: 100%;
	}

	table thead th {
		padding: 10px 0;
		font-weight: 400;
	}

	tbody tr {
		display: table-row;
		vertical-align: inherit;
		border-color: inherit;
	}

	.month-table tbody td {
		vertical-align: inherit;
		border-right: 1px solid #ebeef5;
		border-bottom: 1px solid #ebeef5;
	}

	.month-table tbody tr:first-child td {
		border-top: 1px solid #ebeef5;
	}

	.month-table tr td:first-child {
		border-left: 1px solid #ebeef5;
	}

	.date {
		box-sizing: border-box;
		padding: 8px;
		height: 160px;
		overflow: auto;
	}
  .date::-webkit-scrollbar {
  	width: 5px;
  	height: 4px;
  	background-color: #f5f5f5;
  }
  
  .date::-webkit-scrollbar-thumb {
  	border-radius: 3px;
  	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
  	background: #cae1f5;
  }
  
  .date::-webkit-scrollbar-track {
  	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  	background: #fff;
  }
	.not-current-month {
		color: #909399;
	}

	.current-month {
		color: #000000;
	}

	.today {
		color: #000000;
		background-color: #F5FBFF;
	}

	.date-alive {
		background-color: rgb(252, 212, 215);
	}

	.week-table tbody tr td {
		border: 1px solid #ebeef5;
	}

	.hours {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
</style>
